import { Component } from "@angular/core";
@Component({
  selector: "app-login-assistant",
  templateUrl: "./login-assistant.component.html",
  styleUrls: ["./login-assistant.component.scss"]
})
export class LoginAssistantComponent {
}


